import axios from 'axios';

const API = axios.create({
  baseURL: '/api'
});

// إرفاق التوكن تلقائياً بكل طلب لو موجود
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ===== المستخدمين =====
export const fetchCustomers = () => API.get('/admin/customers');

export const fetchStaff = () => API.get('/admin/staff');

export const fetchLocalCustomersApi = () => API.get('/admin/local-customers');

export const updateLocalCustomerApi = (id, data) =>
  API.put(`/admin/local-customers/${id}`, { name: data.name, phone: data.phone });

export const deleteLocalCustomerApi = (id) => API.delete(`/admin/local-customers/${id}`);

export const addStaffApi = ({ fullName, email, phone, password, canEdit }) =>
  API.post('/admin/staff', {
    name: fullName,
    email,
    phone,
    password,
    canEdit: String(canEdit)
  });

export const deleteUserApi = (id) => API.delete(`/admin/users/${id}`);

export const resetPasswordApi = (id, password) =>
  API.put(`/admin/users/${id}/password`, { password });

export const updateUserApi = (id, data) => API.put(`/admin/users/${id}`, data);

export const updateAdminProfileApi = (data) => API.put('/admin/me', data);

// ===== الحساب =====
export const requestCodeApi = () => API.post('/account/request-code');

export const changeEmailApi = (newEmail, code) =>
  API.post('/account/change-email', { newEmail, code });

export const resetPasswordWithCodeApi = (newPassword, code) =>
  API.post('/account/reset-password', { newPassword, code });

// ===== المصادقة — رموز التحقق بالبريد (Resend) =====
export const requestRegisterCodeApi = (email) =>
  API.post('/auth/register/request-code', { email });

export const requestForgotPasswordCodeApi = (email) =>
  API.post('/auth/forgot-password/request-code', { email });

// ===== استرجاع بيانات المستخدم الحالي من التوكن =====
export const fetchCurrentUserApi = () => API.get('/auth/me');

export const resetForgotPasswordApi = (email, code, newPassword) =>
  API.post('/auth/forgot-password/reset', { email, code, newPassword });

// ===== سجل الحجوزات الملغية (الزبون نفسه، أو المدير عبر userId) =====
export const fetchCancelledBookingsApi = (userId) =>
  API.get('/reservations/cancelled', { params: userId ? { userId } : {} });

// ===== الفعاليات =====
export const fetchEventsApi = () => API.get('/events');

export const createEventApi = (data) =>
  API.post('/events', {
    title: data.title,
    rawDate: data.rawDate || data.date,
    time: data.time,
    endTime: data.endTime || null
  });

export const updateEventApi = (id, data) =>
  API.put(`/events/${id}`, {
    title: data.title,
    rawDate: data.rawDate || data.date,
    time: data.time,
    endTime: data.endTime || null
  });

export const deleteEventApi = (id) => API.delete(`/events/${id}`);

export const fetchDeletedEventsApi = () => API.get('/events/deleted');

export const restoreEventApi = (id) => API.post(`/events/${id}/restore`);

export const purgeEventApi = (id) => API.delete(`/events/${id}/purge`);

// ===== المقاعد =====
export const addSeatApi = (eventId, data) =>
  API.post(`/events/${eventId}/seats`, {
    id: data.id,
    type: data.type,
    floor: data.floor,
    name: data.name,
    info: data.info,
    price: data.price
  });

export const deleteSeatApi = (eventId, seatKey) =>
  API.delete(`/events/${eventId}/seats/${seatKey}`);

export const updateSeatApi = (eventId, seatKey, data) =>
  API.put(`/events/${eventId}/seats/${seatKey}`, {
    name: data.name,
    info: data.info,
    price: data.price
  });

export const bulkUpdateSeatsApi = (eventId, data) =>
  API.put(`/events/${eventId}/seats/bulk`, {
    type: data.type,
    floor: data.floor,
    info: data.info,
    price: data.price
  });

// ===== الحجز =====
export const bookSeatApi = (eventId, seatKey) =>
  API.post(`/events/${eventId}/seats/${seatKey}/book`);

export const internalBookSeatApi = (eventId, seatKey, data) =>
  API.post(`/events/${eventId}/seats/${seatKey}/internal`, {
    name: data.name,
    phone: data.phone,
    note: data.note,
    paidCash: data.paidCash,
    paidNetwork: data.paidNetwork
  });

export const editInternalBookingApi = (eventId, seatKey, data) =>
  API.put(`/events/${eventId}/seats/${seatKey}/internal`, {
    name: data.name,
    phone: data.phone,
    note: data.note,
    paidCash: data.paidCash,
    paidNetwork: data.paidNetwork
  });

export const reopenSeatApi = (eventId, seatKey) =>
  API.post(`/events/${eventId}/seats/${seatKey}/reopen`);

export const cancelMyReservationsApi = (data = {}) =>
  API.delete('/reservations/mine', { data });

// ===== إعدادات الأسعار الافتراضية للمقاعد =====
export const fetchSeatPricingApi = () => API.get('/settings/seat-pricing');

export const updateSeatPricingApi = (data) =>
  API.put('/settings/seat-pricing', {
    chairPrice: data.chairPrice,
    sessionPrice: data.sessionPrice,
    vipPrice: data.vipPrice,
    chairInfo: data.chairInfo,
    sessionInfo: data.sessionInfo,
    vipInfo: data.vipInfo
  });

export const resetSeatPricingApi = () => API.post('/settings/seat-pricing/reset');

export default API;